import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { ButtonBar } from 'components';
import { Field } from 'formik';

export const Wrapper = styled.div``;

export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;

export const InputRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
`;

export const InputName = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 50%;
`;
export const InputMemo = styled.div`
    margin-top: 16px;
`;

export const InputAmount = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 50%;
    margin-left: 16px;
`;

export const Label = styled.div`
    font-size: 16px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-bottom: 8px;
`;

export const FormField = styled(Field)`
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 32px;
    margin-bottom: 16px;
    text-align: right;
`;
